<!--
 * @Author: xuesong
 * @Date: 2021-04-26 13:40:11
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-05-12 18:18:09
 * @Description: 随访记录
-->
<template>

    <!-- <div class="info-content">
    <div>
      <img
        src="https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=3227306127,2865995350&fm=26&gp=0.jpg"
        alt=""
      />
    </div>
    <div>
      <div>{{ data.tagName }}</div>
      <div>{{ data.desc }}</div>
      <div>随访记录表</div>
    </div>
  </div> -->
 
  <div class="custom-9" :style="{backgroundColor: bgColor,color: color}">
  <div class="info-content">
      <div class="left">
        <div class="left-img">
          <img src="../../static/IM/nines-msg.png" alt="" />
        </div>
        <div class="left-content">
          <div class="title">{{ data.tagName }}</div> 
          <div class="descript">{{ data.desc }}</div> 
          <div class="descript">随访记录表</div>         

        </div>
      </div>
      <div class="right">
        <div class="btn">立即查看</div>
      </div>
    </div>
</div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="less" scoped>
.custom-9{
 border-radius: 4px;
  width: 350px;
  border-radius: 4px;
  
  .info-content {
    padding: 15px 20px;
    font-size: 12px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      .left-img {
        margin-right: 15px;
        img {
          width: 60px;
          height: 60px;
        }
      }
      .left-content {
        display: flex;
        flex-direction: column;
        // align-items: center;
        justify-content: center;

        .title {
          font-size: 12px;
          font-weight: 600;
          color: #333;
        }
      }
    }
    .right{
      .btn{
        width: 62px;
        height: 27px;
        border-radius: 14px;
        border: 1px solid #DD8B03;

        font-size: 12px;
        color: #DD8B03;
        line-height: 27px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
</style>